(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 768px)');
  const MIN_THUMB_PX = 24;
  const BOUND_ATTR = 'data-we-featured-bound';
  const DRAG_THRESHOLD = 10;

  function getScrollStep(track) {
    const item = track.querySelector('.we-featured-products__item');
    if (!item) return track.clientWidth;

    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return item.offsetWidth + gap;
  }

  function updateProgress(track, progress, fill) {
    if (!track || !progress || !fill) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const canScroll = maxScroll > 1;

    progress.hidden = !canScroll;
    if (!canScroll) return;

    const trackWidth = progress.clientWidth;
    const thumbWidth = Math.max((track.clientWidth / track.scrollWidth) * trackWidth, MIN_THUMB_PX);
    const maxTranslate = Math.max(trackWidth - thumbWidth, 0);
    const ratio = track.scrollLeft / maxScroll;

    fill.style.width = thumbWidth + 'px';
    fill.style.transform = 'translateX(' + ratio * maxTranslate + 'px)';
  }

  function updateNav(track, prevBtn, nextBtn) {
    if (!track || !prevBtn || !nextBtn) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const canScroll = maxScroll > 1;

    prevBtn.disabled = !canScroll || track.scrollLeft <= 1;
    nextBtn.disabled = !canScroll || track.scrollLeft >= maxScroll - 1;
  }

  function getMaxScroll(track) {
    return Math.max(track.scrollWidth - track.clientWidth, 0);
  }

  function bindTrackScrollEnd(track) {
    if (!track || track.getAttribute('data-we-featured-scroll-end') === 'true') return;

    track.setAttribute('data-we-featured-scroll-end', 'true');

    track.addEventListener(
      'scroll',
      () => {
        const maxScroll = getMaxScroll(track);
        if (maxScroll <= 1) return;

        if (track.scrollLeft > maxScroll) {
          track.scrollLeft = maxScroll;
        }
      },
      { passive: true }
    );
  }

  function bindCardNavigation(track) {
    if (!track || track.getAttribute('data-we-featured-cards-bound') === 'true') return;

    track.setAttribute('data-we-featured-cards-bound', 'true');

    let pointerStart = null;
    let dragged = false;
    let activePointerId = null;

    const resetPointer = () => {
      pointerStart = null;
      activePointerId = null;
    };

    track.addEventListener(
      'pointerdown',
      (event) => {
        if (event.button !== 0) return;

        pointerStart = { x: event.clientX, y: event.clientY };
        dragged = false;
        activePointerId = event.pointerId;
      },
      { passive: true }
    );

    track.addEventListener(
      'pointermove',
      (event) => {
        if (!pointerStart || event.pointerId !== activePointerId) return;

        const dx = Math.abs(event.clientX - pointerStart.x);
        const dy = Math.abs(event.clientY - pointerStart.y);

        if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
          dragged = true;
        }
      },
      { passive: true }
    );

    track.addEventListener('pointerup', (event) => {
      if (event.pointerId !== activePointerId) return;
      resetPointer();
    });

    track.addEventListener('pointercancel', (event) => {
      if (event.pointerId !== activePointerId) return;
      resetPointer();
    });

    track.addEventListener('click', (event) => {
      if (dragged) {
        event.preventDefault();
        dragged = false;
        return;
      }

      if (event.target.closest('a[href], button')) return;

      const card = event.target.closest('[data-plp-card]');
      const url = card?.dataset.productUrl;
      if (url) window.location.assign(url);
    });
  }

  function bindSection(section) {
    if (section.getAttribute(BOUND_ATTR) === 'true') return;

    const track = section.querySelector('[data-we-featured-track]');
    const progress = section.querySelector('[data-we-featured-progress]');
    const fill = section.querySelector('[data-we-featured-progress-fill]');
    const nav = section.querySelector('[data-we-featured-nav]');
    const prevBtn = section.querySelector('[data-we-featured-prev]');
    const nextBtn = section.querySelector('[data-we-featured-next]');

    if (!track) return;

    section.setAttribute(BOUND_ATTR, 'true');
    bindCardNavigation(track);
    bindTrackScrollEnd(track);

    const sync = () => {
      const canScroll = track.scrollWidth - track.clientWidth > 1;

      if (nav) {
        nav.hidden = !canScroll || !DESKTOP_MQ.matches;
      }

      updateProgress(track, progress, fill);
      updateNav(track, prevBtn, nextBtn);
    };

    const onScroll = () => {
      updateProgress(track, progress, fill);
      updateNav(track, prevBtn, nextBtn);
    };

    prevBtn?.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollStep(track), behavior: 'smooth' });
    });

    nextBtn?.addEventListener('click', () => {
      track.scrollBy({ left: getScrollStep(track), behavior: 'smooth' });
    });

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', sync);
    DESKTOP_MQ.addEventListener('change', sync);
    document.addEventListener('theme:resize:width', sync);

    sync();
  }

  function init(root) {
    root.querySelectorAll('[data-we-featured-products]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.('[data-we-featured-products]')
      ? event.target
      : event.target.querySelector?.('[data-we-featured-products]');

    if (!section) return;

    section.removeAttribute(BOUND_ATTR);
    section.querySelector('[data-we-featured-track]')?.removeAttribute('data-we-featured-cards-bound');
    section.querySelector('[data-we-featured-track]')?.removeAttribute('data-we-featured-scroll-end');
    bindSection(section);
  });
})();
